import { useMedia } from 'react-use';

export const useMediaLarge = () => useMedia('(min-width: 1025px)');

export const useMediaSmall = () => useMedia('(max-width: 641px)');
